// extracted by mini-css-extract-plugin
module.exports = {"overlay":"AuthInfo_overlay__hcHel","fadeIn":"AuthInfo_fadeIn__oQ_9H","loader":"AuthInfo_loader__zq_B7","spin":"AuthInfo_spin__djgaR"};